<script setup lang="ts">
// @ts-nocheck
import { ref } from "vue";
const props = defineProps({
  icon: { type: String, required: true },
  item: { type: Object, required: true },
  mapRef: { type: Object, required: true },
  move1: { type: Object, required: true }, // 用于获取地图坐标
  onDrop: { type: Function, required: false },
});
const emit = defineEmits(["dragstart", "dragend"]);
const activatedDragItem = ref();

function handleDragStart(evt: DragEvent) {
  activatedDragItem.value = props.item;
  emit("dragstart", props.item);
}

function handleDragEnd(evt: DragEvent) {
  // 获取屏幕像素坐标
  const pixel = [evt.screenX, evt.screenY];
  setTimeout(() => {
    // 兼容 mapRef 直接是 map 或 mapRef.map
    const mapInstance = props.mapRef?.getMap();
    if (!mapInstance) {
      console.error("mapRef is not valid:", props.mapRef);
      return;
    }
    const viewCoordinate = props.move1.value; // <--- 补上这行
    const zoom = mapInstance.getView().getZoom();
    // 触发onDrop回调或emit事件
    if (props.onDrop) {
      props.onDrop({
        coordinate: viewCoordinate,
        zoom,
        item: activatedDragItem.value,
        pixel,
      });
    }
    emit("dragend", {
      coordinate: viewCoordinate,
      zoom,
      item: activatedDragItem.value,
      pixel,
    });
  }, 100);
}
</script>

<template>
  <img
    :src="icon"
    draggable="true"
    class="!w-8"
    @dragstart="handleDragStart"
    @dragend="handleDragEnd"
  />
</template>
